import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
      color: theme.palette.text.primary,
    },
  });

interface DescriptionProps extends WithStyles<typeof styles> {
  fieldId: string;
  description: string;
  allowHtml?: boolean;
}

export const DescriptionComponent = (props: DescriptionProps) => {
  const { classes, allowHtml } = props;

  const description = allowHtml ? <span dangerouslySetInnerHTML={{ __html: props.description }} /> : props.description;

  return description ? (
    <Typography className={classes.root} component="div">
      {description}
    </Typography>
  ) : null;
};

export const Description = withStyles(styles)(DescriptionComponent);
